import './Audio.css';

import { cn } from 'component-library/utils';
import { useTranslation } from 'react-i18next';

export type AudioProps = {
  url: string;
  width?: number;
  height?: number;
  className?: string;
  applyDefaultStyles?: boolean;
};

export const Audio = ({ url, className, height, width, applyDefaultStyles = true }: AudioProps) => {
  const { t } = useTranslation();

  return (
    <audio
      controls
      className={cn(applyDefaultStyles && 'audio', className)}
      style={{
        height: `${height}px`,
        width: `${width}px`,
      }}
    >
      <source src={url} type='audio/mp3' />
      <source src={url} type='audio/ogg' />
      <source src={url} type='audio/wav' />
      {t('global.audioNotSupported')}
      <track kind='captions' />
    </audio>
  );
};
